import React, { useEffect, useState } from 'react';
import './ConfirmationModal.css';
import { triggerHaptic } from '../services/telegram';
import { PAYMENT_METHODS } from '../utils/paymentMethod';
import sbpIcon from '../images/payment/sbp.svg';
import sberPayIcon from '../images/payment/sberpay.svg';
import { CardIcon, PaymentIconImg } from './PaymentIcons';

const METHOD_DESCRIPTIONS = {
  sbp: 'Оплата новым счётом СБП',
  sber_pay: 'Оплата новым SberPay',
  card: 'Оплата новой картой',
};

const METHOD_ICONS = {
  sbp: sbpIcon,
  sber_pay: sberPayIcon,
  card: null,
};

function ConfirmationModal({
  isOpen,
  onClose,
  plan,
  tariffId,
  formatDateEnd,
  userId,
  paymentMethod = 'card',
  onChangePaymentMethod,
  onConfirm,
}) {
  const [autorenewConsent, setAutorenewConsent] = useState(false);

  useEffect(() => {
    if (isOpen) setAutorenewConsent(false);
  }, [isOpen, plan?.id]);

  if (!isOpen) return null;

  const dateEnd = plan && formatDateEnd ? formatDateEnd(plan.months) : '';
  const monthWord =
    plan && plan.months === 1
      ? 'месяц'
      : plan && plan.months >= 2 && plan.months <= 4
        ? 'месяца'
        : 'месяцев';

  const subscriptionText = plan
    ? `Подписка до ${dateEnd}, ${plan.months} ${monthWord}`
    : '';

  const displayPrice = plan ? plan.price : 0;

  const method =
    PAYMENT_METHODS.find((m) => m.id === paymentMethod) || PAYMENT_METHODS[PAYMENT_METHODS.length - 1];
  const methodText = METHOD_DESCRIPTIONS[method.id] || `Оплата методом ${method.label}`;
  const methodIconSrc = METHOD_ICONS[method.id];
  const isCard = method.id === 'card';

  const handleBackgroundClick = () => {
    triggerHaptic();
    setAutorenewConsent(false);
    onClose?.();
  };

  const handleCloseClick = () => {
    triggerHaptic();
    setAutorenewConsent(false);
    onClose?.();
  };

  const handleEditMethodClick = (e) => {
    e.stopPropagation();
    triggerHaptic();
    onChangePaymentMethod?.();
  };

  const handleConfirmClick = () => {
    triggerHaptic();
    if (!userId || !plan) return;
    const consent = autorenewConsent === true;
    setAutorenewConsent(false);
    onConfirm?.({ autorenewConsent: consent });
  };

  const handleAutorenewChange = (event) => {
    setAutorenewConsent(event.target.checked);
    triggerHaptic();
  };

  return (
    <div className="confirmation-overlay" onClick={handleBackgroundClick}>
      <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="confirmation-close"
          onClick={handleCloseClick}
          aria-label="Закрыть"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <h2 className="confirmation-title">Подтверждение</h2>

        <div className="confirmation-main-card">
          <div className="confirmation-main-line">
            {subscriptionText}
          </div>
          <div className="confirmation-main-divider" />
          <div className="confirmation-main-line confirmation-main-line-secondary">
            Количество устройств неограниченно
          </div>
        </div>

        <div className="confirmation-method-card">
          <div className="confirmation-method-left">
            <div className="confirmation-method-icon">
              {isCard ? (
                <CardIcon className="confirmation-method-icon-img confirmation-method-icon-svg" />
              ) : methodIconSrc ? (
                <PaymentIconImg
                  src={methodIconSrc}
                  alt={methodText}
                  className="confirmation-method-icon-img"
                />
              ) : null}
            </div>
            <span className="confirmation-method-text">{methodText}</span>
          </div>
          <button
            type="button"
            className="confirmation-method-edit"
            onClick={handleEditMethodClick}
          >
            Изменить
          </button>
        </div>

        <label className="confirmation-autorenew-option">
          <input
            type="checkbox"
            className="confirmation-autorenew-checkbox"
            checked={autorenewConsent}
            onChange={handleAutorenewChange}
          />
          <span className="confirmation-autorenew-control" aria-hidden="true">
            <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 5.5L5.2 9L12.5 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="confirmation-autorenew-text">
            Включить автопродление: после окончания подписки списывать {displayPrice} Р за{' '}
            {plan.label.toLowerCase()}. Автопродление можно отключить в любое время.
          </span>
        </label>

        <button
          type="button"
          className="confirmation-pay-button"
          onClick={handleConfirmClick}
          disabled={!userId || !plan}
        >
          Оплатить {displayPrice} Р
        </button>
      </div>
    </div>
  );
}

export default ConfirmationModal;
